import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/home/homeProject";

export default class HomeProjectsService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
